/** @file A rotation mirrored across the plane x = 0 (left/right twins). */
import type { Quat } from './quat';

/**
 * `M R M` with M = diag(-1, 1, 1). A rotation axis is a pseudovector, so it maps to `-M axis = (ax, -ay, -az)`
 * while the angle is kept: `[x, -y, -z, w]`. In yaw/pitch/roll terms yaw and roll negate and pitch stays.
 */
export function quatMirrorX(q: Quat): Quat {
  return [q[0], -q[1], -q[2], q[3]];
}
